module.exports = require('./helpers/bundle-url').getBundleURL('hTOHX') + "logo-dark.eefe0b7f.svg";